
import Vue from "vue";

export default Vue.extend({
  name: "favorite-btn",
  props: {
    placeIdHash: { type: String, required: true },
    isFavoriteOn: { type: Boolean, default: false },
    playFavoriteOnAnime: { type: Boolean, default: false },
    playFavoriteOffAnime: { type: Boolean, default: false },
    onCardView: { type: Boolean, default: false },
  },
  data() {
    return {
      btnSize: "46px",
      animeSrc: {
        staticOn: require("@/assets/images/animation/favorite/favorite_on_noborder_static.svg"),
        staticOff: require("@/assets/images/animation/favorite/favorite_off_noborder_static.svg"),
        on: require("@/assets/images/animation/favorite/favorite_on_noborder.svg"),
        off: require("@/assets/images/animation/favorite/favorite_off_noborder.svg"),
      },
    };
  },
  computed: {
    isPC(): boolean {
      return this.$store.state.ui.isPC;
    },
    setOnAnime(): string {
      return `${this.animeSrc.on}?lastmod=${new Date().getTime()}`;
    },
    setOffAnime(): string {
      return `${this.animeSrc.off}?lastmod=${new Date().getTime()}`;
    },
    btnSizeNum(): number {
      return Number(this.btnSize.substring(0, this.btnSize.length - 2));
    },
    btnTitle(): string {
      return this.isFavoriteOn === true
        ? this.$i18n.t("Favorite.removeFavorite").toString()
        : this.$i18n.t("Favorite.promptTitle").toString();
    },
  },
  created() {
    if (this.isPC || this.onCardView) {
      this.btnSize = "36px";
    } else {
      this.btnSize = "46px";
    }
  },
  methods: {
    favoriteBtnClicked(placeIdHash: string) {
      if (this.isFavoriteOn === true) {
        this.deleteFavoritePlace(placeIdHash);
      } else if (this.isFavoriteOn === false) {
        this.createFavoritePlace(placeIdHash);
      }
    },
    createFavoritePlace(placeIdHash: string) {
      // GA, GTM tracking
      this.$gtag.event("click", {
        event_category: "Create favorite",
        event_label: placeIdHash,
        value: 1,
      });
      this.$emit("favorite-checked", placeIdHash);
    },
    deleteFavoritePlace(placeIdHash: string) {
      // GA, GTM tracking
      this.$gtag.event("click", {
        event_category: "Delete favorite",
        event_label: placeIdHash,
        value: 1,
      });
      this.$emit("favorite-unchecked", placeIdHash);
    },
  },
});
